
/**
 * @typedef {('interacted' | 'not-interacted' | 'initial-interaction' )} interactionState
 * @typedef {('valid' | 'invalid')} validationState
 * @typedef {{interactionState: interactionState, validationState: validationState}} inputState
 */
/**
     * A input can be in a state of 'interacted', 'interacting' or 'not interacted'.
     * In our case we want to do user-invalid behaviour when the input is in the 'interacted' state.
     * This is once an interaction has taken place we are not always intereacted with 
     * 
     * @param {inputState} state 
     * @param {(
*  {type: 'server-error'} |
*  {type: 'form-validated', validationState: validationState } |
*  {type: 'input', validationState: validationState } |
*  {type: 'blur',  validationState: validationState })} action 
* @returns {inputState}
*/
export const StateReducer = (state, action) => {
    switch (action.type) {
        case 'server-error':
            return { interactionState: 'interacted', validationState: 'invalid' };
        case 'form-validated':
            return { interactionState: 'interacted', validationState: action.validationState };
        case 'input':
            return state.interactionState === 'not-interacted' || state.interactionState === 'initial-interaction' ?
                { interactionState: 'initial-interaction', validationState: action.validationState } :
                { interactionState: 'interacted', validationState: action.validationState };
        case 'blur':
            return state.interactionState === 'interacted' || state.interactionState === 'initial-interaction' ?
                { interactionState: 'interacted', validationState: action.validationState } :
                { interactionState: 'not-interacted', validationState: action.validationState };
    }
}